import { getLegacyBindingContext } from "@visactor/vrender-core/legacy/bootstrap";

import { registerPolygonGraphic } from "@visactor/vrender-core/register/graphic";

import { polygonModule } from "@visactor/vrender-core/graphic/modules";

import { browser } from "./env";

import { bindPolygonCanvasPickerContribution } from "../picker/contributions/canvas-picker/polygon-module";

import { bindPolygonMathPickerContribution } from "../picker/contributions/math-picker/polygon-module";

function _registerPolygon() {
    if (_registerPolygon.__loaded) return;
    _registerPolygon.__loaded = !0;
    const legacyContext = getLegacyBindingContext();
    registerPolygonGraphic(), polygonModule({
        bind: legacyContext.bind
    }), browser ? bindPolygonCanvasPickerContribution(legacyContext) : bindPolygonMathPickerContribution(legacyContext);
}

_registerPolygon.__loaded = !1;

export const registerPolygon = _registerPolygon;
//# sourceMappingURL=register-polygon.js.map